import EstimateItem from "@/usecases/orders/estimate-item";

export default class EstimatePurchaseItem {
  public id: string = "";
  public rowUuid: string = "";
  public unitName: string = "";
  public unitType: string = "";
  public unitPrice: number = 0;
  public amount: number = 0;
  public totalPrice: number = 0;
  public unitLoss: number = 0;
  public loss: number = 0;
  public expenseCategoryId: string = "";
  public memo: string = "";
  public purchased: boolean = false;
  public purchasedRow: boolean = false;
  public vendorName: string = "";
  public items: EstimatePurchaseItem[] = [];

  public constructor(item: EstimateItem) {
    this.id = item.id;
    this.rowUuid = item.rowUuid;
    this.unitName = item.unitName;
    this.unitType = item.unitType;
    this.unitPrice = item.unitPrice;
    this.amount = item.amount;
    this.totalPrice = item.totalPrice;
    this.unitLoss = item.unitLoss;
    this.loss = item.loss;
    this.expenseCategoryId = item.expenseCategoryId;
    this.memo = item.memo;
    this.purchased = item.purchased;
    this.purchasedRow = item.purchasedRow;
    this.vendorName = item.vendorName;
    this.items = item.items.map(i => new EstimatePurchaseItem(i));
  }

  get selected(): boolean {
    if (this.items.length > 0) {
      return this.items.some(i => i.selected && !this.isPurchasedRow());
    }
    return this.isSelected && !this.isPurchasedRow();
  }

  set selected(selected: boolean) {
    // b-checkがバグを持っていて、小項目をクリック時に大項目クリックの処理が走ってしまうので処理を追加
    // bootstrap-vueのb-checkのバグで、checkedを変更した際にinputが走ってしまう。
    // ToDo bootstrap-vueのバージョンアップで改善するかも.
    if (
      this.items.length > 0 &&
      !this.items.some(i => i.selected) &&
      this.isSelected == false
      // 小項目クリック時に大項目チェックが入るが、その時に小項目全てにチェックが入ってしまうのを防ぐため条件追加
    ) {
      // 大項目をチェックしたら該当する小項目全てにチェックを入れる。
      this.items.forEach(i => {
        i.selected = true;
      });
    } else {
      // 小項目をクリックしたらそれだけをチェックする。
      this.isSelected = selected;
    }
    if (
      this.items.length > 0 &&
      this.isSelected == false
      // 大項目のチェックを外したら走らせる。上のif文では感知できないため
    ) {
      // 大項目のチェックを外したら該当する小項目全てのチェックを外す。
      this.items.forEach(i => {
        i.selected = selected;
      });
    }
  }
  private isSelected = false;

  public isPurchasedRow(): boolean {
    if (this.items.length > 0) {
      return this.items.every(item => item.isPurchasedRow());
    } else {
      return this.purchasedRow;
    }
  }
}
